import type { TelegramLoginWidgetInput } from '@upme/contracts';
import { api } from '../../app/api-client';
import type { Session } from './auth-context';
import { authAdapter } from './memory-access-adapter';

export interface ExchangeResponse {
  accessToken: string;
  user: Session['user'];
  adminRoles: Session['adminRoles'];
}

export function exchangeLoginWidget(payload: TelegramLoginWidgetInput): Promise<ExchangeResponse> {
  return api.post('auth/telegram/login-widget', { json: payload }).json<ExchangeResponse>();
}

export function devLogin(): Promise<ExchangeResponse> {
  return api.post('auth/dev/login', { json: {} }).json<ExchangeResponse>();
}

export function logoutRequest(): Promise<void> {
  return api.post('auth/logout').then(() => undefined);
}

interface MeResponse {
  user: Session['user'] & { adminRoles: Session['adminRoles'] };
  city: unknown;
}

/**
 * Tries to restore session from refresh-cookie at app start.
 * On success: writes access token to authAdapter and fetches /me to build a full Session.
 * On failure: clears authAdapter and returns null.
 */
export async function bootstrapSession(): Promise<Session | null> {
  try {
    const { accessToken } = await api.post('auth/refresh').json<{ accessToken: string }>();
    authAdapter.setAccess(accessToken);
    const me = await api.get('me').json<MeResponse>();
    return {
      accessToken,
      user: {
        id: me.user.id,
        firstName: me.user.firstName,
        lastName: me.user.lastName ?? null,
        username: me.user.username ?? null,
      },
      adminRoles: me.user.adminRoles,
    };
  } catch {
    authAdapter.clear();
    return null;
  }
}
